export default "__VITE_ASSET__Bsf9$5nA__"